import React from 'react';
import { Paper } from '@mui/material';
import AttacksTab from './tabs/AttacksTab';
import DecoysTab from './tabs/DecoysTab';
import CVETab from './tabs/CVETab';
import HoneytokensTab from './tabs/HoneytokensTab';
import EnumerationTab from './tabs/EnumerationTab';
import OldProtocolsTab from './tabs/OldProtocolsTab';

function WorkstationArea({ activeTab }) {
  const renderContent = () => {
    switch (activeTab) {
      case 'Attacks':
        return <AttacksTab />;
      case 'Decoys':
        return <DecoysTab />;
      case 'CVE':
        return <CVETab />;
      case 'Enumeration':
        return <EnumerationTab />;
      case 'Old Protocols':
        return <OldProtocolsTab />;
      case 'Honeytokens':
        return <HoneytokensTab />;
      case 'SIEM':
        return (
          <div style={{ padding: 16 }}>
            SIEM is disabled in the hosted demo.
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        minHeight: '80vh',
      }}
    >
      {renderContent()}
    </Paper>
  );
}

export default WorkstationArea; 